<template>
  <b-row>
    <b-col>
      <div class="mt-4">
        <b-button
          class="debug-button"
          @click="debug = !debug"
        >
          {{ debug_label }}
        </b-button>
        <div
          v-if="debug"
          class="mt-4 pt-2 pb-2 debug-info px-3"
        >
          <h5>Payment debug info</h5>
          <tree-view
            :data="debugData"
            :options="paymentResponseDepth"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
import TreeView from 'vue-json-tree-view'
Vue.use(TreeView)

export default {
  name: 'square-payment-response-debug-wrapper',
  props: {
    debugData: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      debug: false
    }
  },
  computed: {
    debug_label: function() {
      return this.debug ? 'Hide payment debug' : 'Show payment debug'
    },
    paymentResponseDepth: function() {
      return { maxDepth: 5 }
    }
  }

}
</script>

<style lang="scss" scoped>
  .payment-debug-info {
    border: 1px solid black;
    background: #eee;
  }
</style>
